(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"), require("keycloak-js"));
	else if(typeof define === 'function' && define.amd)
		define(["axios", "keycloak-js"], factory);
	else if(typeof exports === 'object')
		exports["samolet-oauth2-pkce"] = factory(require("axios"), require("keycloak-js"));
	else
		root["samolet-oauth2-pkce"] = factory(root["axios"], root["keycloak-js"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__742__, __WEBPACK_EXTERNAL_MODULE__715__) => {
return 